<!--
 * @Description: 表格搜索头部组件
 * @version: 1.0.0
 * @Author: AI Assistant
 * @Date: 2025-01-20
 * @LastEditors: Monkey
 * @LastEditTime: 2025-08-21 11:40:56
-->

<template>
  <el-header class="alljoins-search-header nobg">
    <el-card shadow="never" class="alljoinsComponents alljoins-page-card aj-search-header">
      <!-- 全量搜索区域 -->
      <el-collapse-transition>
        <div v-show="isExpanded" class="aj-search-advanced">
          <slot name="advanced">
            <!-- 默认高级搜索内容 -->
            <div class="aj-search-form">
              <div class="aj-search-items">
                <div class="aj-form-item">
                  <el-input placeholder="请输入搜索关键词" clearable></el-input>
                </div>
                <div class="aj-form-item">
                  <el-button type="primary" icon="el-icon-plus">新增</el-button>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </el-collapse-transition>

      <!-- 简化搜索区域 -->
      <div class="aj-search-simple">
        <div class="aj-search-content">
          <slot name="simple">
            <!-- 默认简化搜索内容 -->
            <div class="left-panel">
              <el-button type="primary" icon="el-icon-plus">新增</el-button>
            </div>
            <div class="right-panel">
              <div class="right-panel-search">
                <el-input placeholder="请输入搜索关键词" clearable></el-input>
                <el-button type="primary" icon="el-icon-search">搜索</el-button>
              </div>
            </div>
          </slot>
        </div>

        <!-- 展开/收起按钮 -->
        <div class="aj-search-toggle">
          <el-button :icon="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            :title="isExpanded ? '收起高级搜索' : '展开高级搜索'" circle size="small" @click="toggleExpanded" />
        </div>
      </div>
    </el-card>
  </el-header>
</template>

<script setup>
import { ref } from 'vue'

// 组件配置
defineOptions({
  name: 'AjSearchHeader',
  inheritAttrs: false
})

// Props定义
const props = defineProps({
  // 是否默认展开高级搜索
  defaultExpanded: {
    type: Boolean,
    default: false
  },
  // 是否显示展开按钮
  showToggle: {
    type: Boolean,
    default: true
  }
})

// Emits定义
const emit = defineEmits(['toggle', 'search', 'reset'])

// 响应式状态
const isExpanded = ref(props.defaultExpanded)

// 切换展开状态
const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value
  emit('toggle', isExpanded.value)
}

// 暴露给父组件的方法
defineExpose({
  expand: () => {
    isExpanded.value = true
    emit('toggle', true)
  },
  collapse: () => {
    isExpanded.value = false
    emit('toggle', false)
  },
  toggle: toggleExpanded,
  isExpanded: () => isExpanded.value
})
</script>

<style lang="scss" scoped>
.alljoins-search-header {
  background: none;
  border-bottom: none;
  margin: 0px;
  padding-bottom: 0px;
}

.aj-search-header {
  .aj-search-simple {
    display: flex;
    align-items: center;
    gap: 12px;

    .aj-search-content {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left-panel {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .right-panel {
        display: flex;
        align-items: center;

        .right-panel-search {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
    }

    .aj-search-toggle {
      flex-shrink: 0;
    }
  }

  .aj-search-divider {
    margin: 16px 0 12px 0;
  }

  .aj-search-advanced {
    .aj-search-form {
      :deep(.el-form) {
        .el-form-item {
          margin-bottom: 12px;
          margin-right: 16px;
        }

        .el-form-item__label {
          font-weight: 500;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .aj-search-header {
    .aj-search-simple {
      .aj-search-content {
        flex-direction: column;
        gap: 12px;
        align-items: stretch;

        .left-panel,
        .right-panel {
          justify-content: center;
        }
      }
    }

    .aj-search-advanced {
      .aj-search-form {
        :deep(.el-form) {
          .el-form-item {
            margin-right: 8px;

            .el-form-item__content {

              .el-input,
              .el-select,
              .el-date-editor {
                width: 100% !important;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .aj-search-header {
    .aj-search-simple {
      .aj-search-content {
        .left-panel {
          flex-wrap: wrap;
        }

        .right-panel {
          .right-panel-search {
            flex-direction: column;
            gap: 8px;
            width: 100%;

            .el-input {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>